import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Switch, Button, message } from 'antd';
import { makePutCall } from '../../utils/helper';
import { getUserDetails } from '../../utils/common';

const { TextArea } = Input;

const EditCenter = ({ visible, center, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (center) {
      form.setFieldsValue({
        name: center.name,
        code: center.code,
        ip: center.ip,
        location: center.location || '',
        contact: center.contact || '',
        active: center.active,
      });
    }
  }, [center, form]);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const response = await makePutCall(`/centres/${center.id}`, {
        ...values,
      });

      if (response.data.success) {
        message.success('Center updated successfully');
        form.resetFields();
        onSuccess();
      } else {
        throw new Error(response.data.message || 'Failed to update center');
      }
    } catch (error) {
      message.error(error.message || 'Failed to update center');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Edit Center"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={800}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        className="admin-form"
      >
        <Form.Item
          label="Center Name"
          name="name"
          rules={[
            { required: true, message: 'Please enter center name' },
            { max: 100, message: 'Name must be less than 100 characters' },
          ]}
        >
          <Input placeholder="Enter center name" />
        </Form.Item>

        <Form.Item
          label="Center Code"
          name="code"
          rules={[
            { required: true, message: 'Please enter center code' },
            { max: 20, message: 'Code must be less than 20 characters' },
          ]}
        >
          <Input placeholder="Enter center code (e.g., CGH)" />
        </Form.Item>

        <Form.Item
          label="IP Address"
          name="ip"
          rules={[
            { required: true, message: 'Please enter IP address' },
            {
              pattern: /^(\d{1,3}\.){3}\d{1,3}$/,
              message: 'Please enter a valid IP address',
            },
          ]}
        >
          <Input placeholder="Enter IP address (e.g., 192.168.1.1)" />
        </Form.Item>

        <Form.Item
          label="Location"
          name="location"
          rules={[
            { max: 200, message: 'Location must be less than 200 characters' },
          ]}
        >
          <Input placeholder="Enter location" />
        </Form.Item>

        <Form.Item
          label="Contact"
          name="contact"
          rules={[
            { max: 100, message: 'Contact must be less than 100 characters' },
            { type: 'email', message: 'Please enter a valid email address' },
          ]}
        >
          <Input placeholder="Enter contact email" />
        </Form.Item>

        <Form.Item
          label="Active Status"
          name="active"
          valuePropName="checked"
        >
          <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
        </Form.Item>

        <Form.Item className="form-actions">
          <Button onClick={handleCancel} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit" loading={loading}>
            Update Center
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditCenter;
